export function saveParse(data: string) {
  try {
    const parseData = JSON.parse(data);
    return parseData;
  } catch (e) {
    console.log('Error parsing ', e.message);
    return '';
  }
}
